import crypto from 'crypto';
import randomstring from 'randomstring';
import CountryQuery from 'country-query';

import { getCmsTemplateContentsRequest } from '../Cms/CmsActions';
import { getUsersRequest, isLoggedInRequest } from '../User/UserActions';
import { getAddressesRequest } from '../Address/AddressActions';
import { getProductsRequest } from '../Product/ProductActions';
import { getOrdersByUserRequest } from '../Order/OrderActions';
import { getPublicConfigRequest } from '../Config/ConfigActions';

import { addError } from '../Error/ErrorActions';

import { version } from '../../../package.json';

import callApi from '../../util/apiCaller';
import { sequence } from '../../util/promises';

// Export Constants
export const INIT_SOCKET = 'INIT_SOCKET';
export const SEND_SOCKET = 'SEND_SOCKET';
export const RECEIVE_SOCKET = 'RECEIVE_SOCKET';
export const SET_REDIRECT = 'SET_REDIRECT';
export const REDIRECT = 'REDIRECT';
export const SET_MOUNTED = 'SET_MOUNTED';
export const UPDATE_TABLE = 'UPDATE_TABLE';
export const INIT_PERSISTED_DATA = 'INIT_PERSISTED_DATA';
export const SET_IS_FETCHING = 'SET_IS_FETCHING';

// Export Request Actions
export function initApp(isSSR = false) {
    return dispatch => {
        return dispatch(isLoggedInRequest()).then(user => {
            const initItems = [getCmsTemplateContentsRequest, getPublicConfigRequest, getProductsRequest];
            if(user) {
                initItems.push(getAddressesRequest, getOrdersByUserRequest);
                switch(user.role) {
                    case 'admin':
                        // initItems.push(getUsersRequest);
                        break;

                    case 'customer':
                    default:
                        // initItems = initItems.concat([]);
                        break;
                }
            // } else {
            }
            return sequence(initItems, dispatch).then(results => {
                !isSSR && dispatch(setMounted());
            });
        });
    };
}

export function initAppRequest() {
    return dispatch => callApi('app/init').then(res => {
        return res.ok;
    }).catch(error => {
        dispatch(addError(error));
    });
}

export function checkVersionRequest() {
    return dispatch => callApi('app/web/version').then(res => {
        if(res.version && res.version !== version && process.env.NODE_ENV !== 'development') {
            typeof window !== 'undefined' && window.location.reload();
        }
        return res.version;
    }).catch(error => {
        dispatch(addError(error));
    });
}

export function createIndexRequest() {
    return dispatch => callApi('app/database/index').then(res => {
            return res.ok;
        }).catch(error => {
            dispatch(addError(error));
        });
}

// Export Actions

export function getTable(store, tableId) {
    return store.app.tables.find(table => table.id === tableId) || {};
}

export function isFetching(store, type) {
    return (store[type] || {}).isFetching || false;
}

export function initSocket(socket) {
    return {
        type: INIT_SOCKET,
        socket,
    };
}

export function sendSocket(datas) {
    // Secure subscribe socket with key
    if(datas && datas.type === 'subscribe' && typeof datas.data === 'object') {
        const salt = randomstring.generate();
        const keyCrypto = crypto.createHash('sha1');
        keyCrypto.update(`${process.env.NODE_ENV}${salt}${datas.data.channel}`);
        const key = keyCrypto.digest('hex');
        datas.data.salt = salt;
        datas.data.key = key;
    }
    return {
        type: SEND_SOCKET,
        data: datas,
    };
}

export function receiveSocket(datas) {
    return {
        type: RECEIVE_SOCKET,
        data: datas,
    };
}

export function subscribeToChannel(channel, addToChannelsList = true) {
    return dispatch => {
        dispatch(sendSocket({ type: 'subscribe', data: { channel } }));
        // addToChannelsList && dispatch(addChannelSubscription(channel));
    };
}

export function unsubscribeToChannel(channel, removeFromChannelsList = true) {
    return dispatch => {
        dispatch(sendSocket({ type: 'unsubscribe', data: { channel } }));
        // removeFromChannelsList && dispatch(removeChannelSubscription(channel));
    };
}

export function initSetMounted() {
    return dispatch => {
        return dispatch(setMounted());
    };
}

// Getters
export function getAvalaibleCountries() {
    let countries = [];
    ['Europe', 'Africa', 'Americas', 'Asia', 'Oceania'].forEach(region => {
        countries = countries.concat(CountryQuery.find('region', region));
    });
    return countries;
}

export function getCountryNameTranslation(item, locale) {
    let name = '';
    switch(locale) {
        case 'fr':
            name = item.translations.fra && item.translations.fra.common;
            break;

        case 'de':
            name = item.translations.deu && item.translations.deu.common;
            break;

        case 'es':
            name = item.translations.spa && item.translations.spa.common;
            break;

        default:
            name = item.name.common;
    }
    return name || item.name.common;
}

// Actions
export function setRedirect(redirect = '') {
    return {
        type: SET_REDIRECT,
        redirect,
    };
}

export function redirect() {
    return {
        type: REDIRECT,
    };
}

export function setMounted() {
    return {
        type: SET_MOUNTED,
    };
}

export function updateTable(tableId, tableData) {
    return {
        type: UPDATE_TABLE,
        tableId,
        tableData,
    };
}

export function initPersistedData() {
    return {
        type: INIT_PERSISTED_DATA,
    };
}

export function setIsFetching(dataType, isFetching = true) {
    return {
        type: SET_IS_FETCHING,
        dataType: dataType.toLowerCase(),
        isFetching,
    };
}
